import React from 'react';

const FiFlag: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="84" height="56" viewBox="0 0 84 56" fill="none">
    <g clipPath="url(#clip0_47_1094)">
      <rect width="91.6364" height="56" transform="translate(-3.81812 4.00543e-05)" fill="white" />
      <path d="M-3.81812 28H87.8183H-3.81812ZM29.2728 4.00543e-05V56V4.00543e-05Z" fill="black" />
      <path
        d="M-3.81812 28H87.8183M29.2728 4.00543e-05V56"
        stroke="#002F6C"
        strokeWidth="15.2727"
      />
    </g>
    <defs>
      <clipPath id="clip0_47_1094">
        <rect
          width="91.6364"
          height="56"
          fill="white"
          transform="translate(-3.81812 4.00543e-05)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default FiFlag;
